<ng-container [ngSwitch]="bookingStore.commercialBookingPlansLoadedState$ | async">
  <div
    class="flex flex-col gap-[40px] lt-md:gap-[16px]"
    *ngSwitchCase="BookingPlansLoadingState.Loaded"
  >
    <ng-container
      *ngIf="
        (bookingStore.error$ | async) === noInstallationsError;
        then bookingPlansError;
        else bookingPlans
      "
    ></ng-container>
    <ng-template #bookingPlans>
      <ng-container *ngIf="bookingStore.subscriptionsPlans$ | async as bookingPlans">
        <div class="plans-wrapper">
          <div class="headers-row flex flex-row">
            <div class="flex-[100%] max-w-[40%]">
              {{ '+BOOKING.PLAN.FEATURE.PACKAGE_CONTENT' | translate }}
            </div>
            <div class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]">
              {{ '+BOOKING.PLAN.FREE_PACKAGE' | translate }}
            </div>
            <div class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]">
              {{ '+BOOKING.PLAN.BASIC_PACKAGE' | translate }}
            </div>
            <div class="flex flex-col justify-start items-center flex-[100%] max-w-[20%]">
              {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.QUICK_CHECK_DASHBOARD' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.QUICK_CHECK_DASHBOARD' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.GUIDED_COMMISSIONING' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.GUIDED_COMMISSIONING' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.SEND_AND_ACCEPT_INVITATIONS' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="
                  '+BOOKING.PLAN.FEATURE.TOOLTIP.SEND_AND_ACCEPT_INVITATIONS' | translate
                "
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.ERROR_LIST' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.ERROR_LIST' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.BASIC_PARAMETERS' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.BASIC_PARAMETERS' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              <span>
                {{ '+BOOKING.PLAN.FEATURE.PARAMETER_COMPARISION' | translate }}
              </span>

              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PARAMETER_COMPARISION' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.SYSTEM_OVERVIEW' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.SYSTEM_OVERVIEW' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.TRENDING' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.TRENDING' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.GUIDED_TROUBLESHOOTING' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.GUIDED_TROUBLESHOOTING' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.PERMANENT_INSPECTION' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PERMANENT_INSPECTION' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.PREDICTIVE_MAINTANANCE' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.PREDICTIVE_MAINTANANCE' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>
          <div class="package-feature">
            <div class="feature-title">
              {{ '+BOOKING.PLAN.FEATURE.AUTOMATED_RECOMMENDATIONS' | translate }}
              <mat-icon
                inline="true"
                [matTooltip]="'+BOOKING.PLAN.FEATURE.TOOLTIP.AUTOMATED_RECOMMENDATIONS' | translate"
                >info_outline
              </mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon class="grey-icon">close</mat-icon>
            </div>
            <div class="icon-container">
              <mat-icon>check</mat-icon>
            </div>
          </div>

          <div class="pro-package-frame">
            <div class="pro-frame-subtitle !hidden gt-md:!block">
              {{ '+BOOKING.PLAN.BEST_SELLING_PACKAGE' | translate }}
            </div>
          </div>
        </div>
        <ng-container *ngIf="authStore.isCompanyFromGermany$ | async">
          <div class="external-advertises">
            <app-additional-services></app-additional-services>
          </div>
        </ng-container>

        <div class="booking-plans-container">
          <div class="video">
            <h1>{{ '+COMMERCIAL_BOOKING.VIGUIDE_EXPLAINED.TITLE' | translate }}</h1>
            <vi-text color="light">
              {{ '+COMMERCIAL_BOOKING.VIGUIDE_EXPLAINED.SUB_TITLE' | translate }}
            </vi-text>
            <div class="video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/Uz4NHSQFWjE"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              >
              </iframe>
            </div>
          </div>
          <div class="plans">
            <app-commercial-booking-plans-spec></app-commercial-booking-plans-spec>
          </div>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #bookingPlansError>
      <div
        class="error-container flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center"
      >
        <img src="assets/img/installer-error.svg" />
        <h1>{{ '+BOOKING.PLANS.ERROR.TITLE' | translate }}</h1>
        <button
          class="back-button"
          gtm="onGoToPage"
          gtmAction="Home Page"
          gtmCategory="booking"
          mat-raised-button
          color="primary"
          [routerLink]="['/installations']"
        >
          <mat-icon>arrow_back</mat-icon>
          <span>{{ '+BOOKING.PLANS.ERROR.BTN' | translate }}</span>
        </button>
      </div>
    </ng-template>
  </div>

  <ng-container *ngSwitchCase="BookingPlansLoadingState.Loading">
    <vi-loader data-at-loader [isLoading]="true"></vi-loader>
  </ng-container>

  <ng-container *ngSwitchCase="BookingPlansLoadingState.Error">
    <div class="flex flex-col gap-[24px] lt-md:gap-[16px] justify-start items-center">
      <img class="error-img" src="assets/img/installer-error.svg" />
      <h1>{{ '+BOOKING.PLANS.ERROR_TIMEOUT_TITLE' | translate }}</h1>
    </div>
  </ng-container>
</ng-container>
